/* eslint-disable no-unused-vars */
import { call, delay, put, select, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";
import { getReqHeader } from "Shared/helpers";
import { balanceActions } from "./balance.slice";
import { selectWithdraw } from "Shared/store/withdraw";
import { walletsActions } from "Features/wallets";
import { errorActions } from "Features/error";

function* getBalace() {
	try {
		const headers = yield call(getReqHeader);
		const { data } = yield call(api.get, "/wallet/tpc", headers);
		yield put(balanceActions.set(data[0]));
	} catch (error) {
		console.error(error);
	}
}

function* withdrawRequest() {
	try {
		const headers = yield call(getReqHeader);
		const wallet = yield select(selectWithdraw.wallet);
		const withdrawParams = yield select(selectWithdraw.withdrawParams);
		yield call(api.post, "/payment/request", { ...wallet, ...withdrawParams }, headers);
		yield put(balanceActions.withdrawSuccess());
		yield put(balanceActions.get());
		const method = yield select(selectWithdraw.method);
		if (method?.length) {
			yield put(walletsActions.get(method));
		}
	} catch (error) {
		console.error(error);
		yield put(balanceActions.withdrawErr());
		yield put(errorActions.addError({ page: "add_wallet", error }));
	}
}

export function* watchBalance() {
	yield takeEvery(balanceActions.get, getBalace);
	yield takeEvery(balanceActions.withdrawReq, withdrawRequest);
}
